import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';

/**
 * This util returns the index of Native Ad in Mail List according to the feature flag.
 */

export const getAdPlacementIndex = () => {
    if (isMiniFeatureEnabled('miniAE-FloatingAd-3rdPosition')) {
        return 2;
    }

    if (isMiniFeatureEnabled('miniAE-FloatingAd-4thPosition')) {
        return 3;
    }

    if (isMiniFeatureEnabled('miniAE-FloatingAd-5thPosition')) {
        return 4;
    }
    return 0;
};
